import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function ActivityLog() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/activity/my").then((r) => setItems(r.data));
  }, []);
  return (
    <div data-testid="activity-log-page">
      <p className="overline">Your account history</p>
      <h1 className="text-3xl font-heading font-medium text-[#0A2540] mt-2 mb-8">Activity Log</h1>
      <div className="card-pb p-6">
        {items.length === 0 ? (
          <p className="text-[#475569]">No activity yet</p>
        ) : (
          <ul className="space-y-4">
            {items.map((a) => (
              <li key={a.activity_id} className="flex gap-4 border-b border-[#E2E8F0] last:border-0 pb-4 last:pb-0" data-testid={`activity-${a.activity_id}`}>
                <div className="w-2 h-2 rounded-full bg-[#C9A356] mt-2 shrink-0"></div>
                <div className="flex-1">
                  <div className="text-sm text-[#0A2540]">{a.description}</div>
                  <div className="text-xs text-[#475569] mt-1">{new Date(a.created_at).toLocaleString()}</div>
                </div>
                <span className="text-xs uppercase tracking-wider text-[#C9A356] font-medium">{a.type}</span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
